import { Button } from "@mui/material";
import { StyledRecommendation } from "./Recommendation.styled";
import { UseFormReturn, useWatch } from "react-hook-form";
import { AccountAdd } from "@models/account";
import { getToastErrorMessage } from "@shared/lib/errors"
import { toast } from 'react-toastify';
import { useLazyAccountRecommendationQuery } from "@features/tickets/api/accounts.api";


interface RecommendationProps {
    useForm: UseFormReturn<AccountAdd>
}

function isSortCodeSelected(sortCode: unknown): sortCode is number {
    return sortCode !== "" && sortCode != null && Number(sortCode) > 0;
}

function Recommendation({ useForm }: RecommendationProps) {
    const [triggerRecommendation] = useLazyAccountRecommendationQuery();

    const sortCode = useWatch({ control: useForm.control, name: "sort_code" });
    const hasSortCode = isSortCodeSelected(sortCode);

    async function handleRecommendation(sortCode: number): Promise<void> {
        const recommendationNumber = await triggerRecommendation(sortCode).unwrap();
        useForm.setValue("account_number", recommendationNumber, { shouldDirty: true });
    }

    function recommendationButtonClicked(sortCode: number) {
        toast.promise(
            handleRecommendation(sortCode),
            {
                error: {
                    render({ data }) {
                        return getToastErrorMessage(data);
                    }
                }
            }
        )
    }

    return (
        <StyledRecommendation>
            <Button
                variant="outlined"
                disabled={!hasSortCode}
                onClick={() => recommendationButtonClicked(Number(sortCode))}
            >
                המלצה
            </Button>
        </StyledRecommendation>
    )
}

export default Recommendation